import styled, {css} from 'styled-components';

const StyledSummaryStyles = css`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 0.25rem;
`;

export const StyledSummary = styled.summary`
  ${StyledSummaryStyles};

  gap: 0.5rem;
`;

const dropdownWrapperStyles = css`
  ${StyledSummaryStyles};
  > * {
    margin-right: 0.2rem;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const StyledDropdownOptionWrapper = styled.div`
  ${dropdownWrapperStyles};
  margin-right: 0.25rem;
  gap: 0.5rem;
`;

export const StyledImg = styled.img`
  width: 1.25rem;
  height: 1rem;
  object-fit: cover;
`;

export const FlagPlaceholder = styled.div`
  width: 1.25rem;
  height: 1rem;
`;

export const StyledDropdownWrapper = styled.div`
  ${dropdownWrapperStyles};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: auto;
  padding-left: 0.5rem;
  gap: 0.5rem;
`;
